import { useMutation } from "@tanstack/react-query";

import { sendInvite } from "../../../api/services";

import { PYUseMutationOptions } from "../StandardQueryArguments";

export const useSendInvite = (options?: PYUseMutationOptions) => {
	return useMutation({
		mutationKey: ["send invite"],
		mutationFn: async (employeeId: string) => await sendInvite(employeeId),
		...options,
	});
};
